import * as ReactGA from "react-ga";

export const initGA = () => {
    if (process.env.NODE_ENV === "production") {
        ReactGA.initialize("UA-203308161-1");
    }
};